/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Typography,
  Grid,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { cloneDeep } from 'lodash';
import get from 'lodash/get';
import LoadingBar from '../share/LoadingBar';
import BasicToolBar from '../share/BasicToolBar';
import {
  commonResourceStyle,
  resourceFormStyle,
} from '../../css/style';
import { TAXES_HELP_TEXT } from '../../data/Constants';
import { searchEntity } from '../../utils/Functions';
import TaxCard from './TaxCard';

const styles = commonResourceStyle();
const iconStyles = resourceFormStyle();

class Taxes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTax: [],
      searchedTerm: null,
    };
  }

  componentDidMount() {
    this.getMenuResources();
  }

  componentDidUpdate(prevProps) {
    const { apiToken } = this.props;
    if (prevProps.apiToken !== apiToken) {
      this.getMenuResources(true);
    }
  }

  getMenuResources = async (forceFetch = false) => {
    const {
      actions, apiToken, locations, loading, taxes,
    } = this.props;
    const { getTaxes } = actions;
    const fromCreateAndEditResource = get(this.props, 'location.state.fromCreateAndEditResource');
    if (!locations || forceFetch || fromCreateAndEditResource) {
      await actions.getAllResources(apiToken, 'locations');
    }
    if (!taxes || loading === false || forceFetch || fromCreateAndEditResource) {
      await getTaxes(apiToken);
    }
    this.assignLocations();
  }

  onClickEdit = (data) => {
    const {
      actions, match, history,
    } = this.props;
    const { resource, resourceId } = match.params;
    actions.clearErrors();
    const resourceName = 'taxes';
    if (resourceId) {
      history.push(`/${resource}/${resourceId}/${resourceName}/${data.id}/edit`);
    } else {
      history.push(`/${resourceName}/${data.id}/edit`);
    }
  }

  onClickDuplicateTax = () => {
    this.getMenuResources(true).then(() => {
      this.updateTaxesLists('duplicate');
    });
  }

  updateTaxesLists = (action, dataId = 0) => {
    const { searchedTerm } = this.state;
    if (searchedTerm) {
      this.setState(prevState => ({
        searchedTax:
          this.updateTaxList(action, prevState.searchedTax, dataId),
      }));
    }
  }

  updateTaxList = (action, taxList, dataId) => {
    if (action === 'duplicate') {
      const { taxes } = this.props;
      const dupTax = cloneDeep(taxes[taxes.length - 1]);
      return [...taxList, dupTax];
    }
    return taxList.filter(tax => tax.id !== dataId);
  }

  handleSearch = (term) => {
    const { taxes } = this.props;
    const searchEntityResult = searchEntity(term, taxes, 'name');
    this.setState({
      searchedTerm: term,
      searchedTax: searchEntityResult,
    });
  }

  handleClearSearch = () => {
    this.setState({
      searchedTerm: null,
    });
  }

  assignLocations() {
    const {
      actions, apiToken, locations, taxes,
    } = this.props;
    if (locations) {
      locations.map(location => actions.getAllResources(apiToken, 'locations', location.id, 'taxes').then(res => res.response.map((taxLocation) => {
        const locationTax = taxes.find(tax => tax.id === taxLocation.id);
        if (locationTax.locationIds) {
          if (locationTax.locationIds.indexOf(location.id) === -1) {
            locationTax.locationIds.push(location.id);
          }
        } else {
          locationTax.locationIds = [location.id];
        }
        return res;
      })));
    }
  }

  moveDisabledToEnd = (taxes) => {
    const copyOfTaxes = cloneDeep(taxes);
    const disabledTaxes = [];
    copyOfTaxes.forEach((tax) => {
      if (tax.disabled) {
        disabledTaxes.push(tax);
      }
    });
    disabledTaxes.forEach((tax) => {
      const index = copyOfTaxes.indexOf(tax);
      copyOfTaxes.splice(index, 1);
      copyOfTaxes.push(tax);
    });
    return copyOfTaxes;
  }

  render() {
    const {
      loading,
      actions,
      taxes,
      apiToken,
      locations,
    } = this.props;
    const {
      searchedTerm,
      searchedTax,
    } = this.state;
    const filteredTaxes = searchedTerm ? searchedTax : taxes;
    const filteredAndPositionedTaxes = this.moveDisabledToEnd(filteredTaxes);
    return (
      (loading === true)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>Taxes</Typography>
              </div>
            </div>
            <div style={styles.taxInnerContainer}>
              <div style={styles.infoContainer}>
                <InfoIcon style={iconStyles.infoIcon} />
                <Typography style={styles.infoText}>{TAXES_HELP_TEXT}</Typography>
              </div>
              <div style={styles.resourceHeader}>
                <BasicToolBar
                  actions={actions}
                  resourceName="taxes"
                  handleSearch={this.handleSearch}
                  handleClearSearch={this.handleClearSearch}
                  onClickAddResourceOverride={this.onClickAddResourceOverride}
                />
              </div>
              <div style={styles.categoryHeaderBorderStyle} />
              <div style={styles.itemsContainer}>
                <Grid
                  container
                  direction='column'
                  style={styles.gridBackground}
                >
                  <div
                    style={styles.categoryContainer}
                  >
                    <div style={styles.itemsListContainer}>
                      <div style={styles.taxesHeaderContainer}>
                        <Typography style={styles.itemsHeaderText}>Tax</Typography>
                        <Typography style={styles.itemsHeaderText}>Percentage</Typography>
                        <Typography style={styles.itemsHeaderText}>Locations</Typography>
                      </div>
                      <div style={styles.itemsHeaderThreeDot} />
                      {
                        filteredAndPositionedTaxes && filteredAndPositionedTaxes.map(tax => (
                          <TaxCard
                            tax={tax}
                            actions={actions}
                            apiToken={apiToken}
                            locations={locations}
                            onClickDuplicate={this.onClickDuplicateTax}
                            onClickEdit={() => this.onClickEdit(tax)}
                          />
                        ))
                      }
                    </div>
                  </div>
                </Grid>
              </div>
            </div>
          </div>
        )
    );
  }
}

Taxes.propTypes = {
  loading: PropTypes.bool.isRequired,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  locations: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  taxes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
};

Taxes.defaultProps = {
  locations: null,
  taxes: null,
};

export default connect(
  state => ({
    loading: state.get('loading').toJS().loading,
    taxes: state.get('taxes').toJS().taxList,
  }),
)(withRouter(Taxes));
